<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="folder_open">
      <mask
        id="mask0_185_13239"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect id="Bounding box" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_185_13239)">
        <path
          id="folder_open_2"
          d="M3.00024 15.0005C2.58774 15.0005 2.23462 14.8536 1.94087 14.5599C1.64712 14.2661 1.50024 13.913 1.50024 13.5005V4.50049C1.50024 4.08799 1.64712 3.73486 1.94087 3.44111C2.23462 3.14736 2.58774 3.00049 3.00024 3.00049H7.50024L9.00024 4.50049H15.0002C15.4127 4.50049 15.7659 4.64736 16.0596 4.94111C16.3534 5.23486 16.5002 5.58799 16.5002 6.00049H8.38149L6.88149 4.50049H3.00024V13.5005L4.80024 7.50049H17.6252L15.694 13.9317C15.594 14.2567 15.4096 14.5161 15.1409 14.7099C14.8721 14.9036 14.5752 15.0005 14.2502 15.0005H3.00024ZM4.57524 13.5005H14.2502L15.6002 9.00049H5.92524L4.57524 13.5005Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
